import React from 'react';
import { Target } from 'lucide-react';
import { useTasks } from '../../contexts/TaskContext';
import { useAuth } from '../../hooks/useAuth';
import { getTasksByPriority } from '../../utils/taskUtils';
import LoadingSpinner from '../common/LoadingSpinner';
import PriorityColumn from '../tasks/PriorityColumn';

const PriorityView = () => {
  const { currentUser } = useAuth();
  const { tasks, loading } = useTasks();

  if (!currentUser) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-8">
        <LoadingSpinner message="Please sign in to view your tasks..." />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-8">
        <LoadingSpinner message="Loading priority dashboard..." />
      </div>
    );
  }

  // Filter out completed tasks for priority view
  const pendingTasks = tasks.filter(task => !task.completed);
  const tasksByPriority = getTasksByPriority(pendingTasks);

  const priorityColumns = [
    {
      title: 'High Priority',
      tasks: tasksByPriority.high,
      colorClass: 'text-red-600',
      emptyMessage: 'No high priority tasks! 🎉'
    },
    {
      title: 'Medium Priority',
      tasks: tasksByPriority.medium,
      colorClass: 'text-yellow-600',
      emptyMessage: 'No medium priority tasks'
    },
    {
      title: 'Low Priority',
      tasks: tasksByPriority.low,
      colorClass: 'text-green-600',
      emptyMessage: 'No low priority tasks'
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-6 py-8">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Today's Priority Dashboard</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {priorityColumns.map((column) => (
          <PriorityColumn key={column.title} {...column} />
        ))}
      </div>
      
      {pendingTasks.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          <Target className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <h3 className="text-lg font-semibold mb-2">No pending tasks</h3>
          <p>All caught up! Create new tasks or check completed ones in Task Manager.</p>
        </div>
      )}
    </div>
  );
};

export default PriorityView;